import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveProvider as RsPrvdr } from 'core/providers/Responsive';

const isMobile = ({ isMobile }) => {
	// maybe use the kwarg ... 🤚
	if (typeof isMobile !== "undefined") return isMobile;
	// maybe use window default ... ☸️
	if (typeof window !== "object" || !window.cj) return isMobile;
	// OMG set the window default ... 💥
	return window.cj.isMobile;
};

const ResponsiveProvider = ({ children, ...rest }) => {
	// these are the crate-ui defaults, just being explicit
	const props = {
		isMobile: true,
		desktopMinWidth: 1024,
		tabletMinWidth: 768,
	};

	// """ Try setting a default """
	rest.isMobile = isMobile(rest);

	return (
		<RsPrvdr {...props} {...rest}>
			{ children }
		</RsPrvdr>
	);
};

ResponsiveProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ResponsiveProvider;
